import { render, staticRenderFns } from "./RemoteConsultationTableCmp4.vue?vue&type=template&id=38cf66f8&"
import script from "./RemoteConsultationTableCmp4.vue?vue&type=script&lang=js&"
export * from "./RemoteConsultationTableCmp4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports